import { convertPropertyNames } from '@/application/helpers/convertPropNames'
import { defineStore } from 'pinia'
import { replaceWordsWithValues } from '@/application/helpers'

interface Translations {
  [key: string]: string
}

export const useLocalizationStore = defineStore('localization', () => {
  // Store translations received from
  const translations = ref<Translations>({})

  // Function to update translations if we get new data
  const updateTranslations = (newTranslations: Translations) => {
    translations.value = convertPropertyNames(newTranslations)
  }

  // Function to translate a key
  const translate = (key: string, placeholder?: Translations) => {
    const translation = translations.value[key] || key

    return replaceWordsWithValues(translation, placeholder)
  }

  const t = (key: string, placeholder?: Translations) => {
    return translate(key, placeholder)
  }

  return {
    updateTranslations,
    translate,
    t
  }
})
